import { sharedQuoteOrderTableHeaders } from '../../../../../shared/utils/shared-quote-order-table-headers';
import { formatProductType, formatAccessProvider, formatQuoteState } from '../../../../utils/quoteTableHelpers';
import {
  SelectColumnFilter,
  SelectSupplierColumnFilter,
} from '../../../../../shared/components/organisms/MultiSelectTable/filters';

const shared = sharedQuoteOrderTableHeaders((row) => row);

const headers = [
  shared.quoteId('id'),
  {
    Filter: SelectColumnFilter,
    Header: 'Product',
    accessor: (row: any) => {
      return formatProductType(row.product_type);
    },
    filter: 'equalsOrEmptyFilter',
    id: 'product',
    width: 110,
  },
  shared.accessTypeForQuote(),
  shared.locations(),
  {
    Filter: SelectSupplierColumnFilter,
    Header: 'Access Provider',
    accessor: (row: any) => formatAccessProvider(row),
    filter: 'equalsOrEmptyFilter',
    id: 'access_provider',
    width: 140,
  },
  shared.price(),
  shared.createdAt(),
  shared.updatedAt(),
  {
    Filter: SelectColumnFilter,
    Header: 'Status',
    accessor: (row: any) => {
      return formatQuoteState(row);
    },
    filter: 'equalsOrEmptyFilter',
    id: 'quote_state',
    width: 100,
  },
];

export default headers;
